import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=a8fc3dec&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=a8fc3dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fc3dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fc3dec')) {
      api.createRecord('a8fc3dec', component.options)
    } else {
      api.reload('a8fc3dec', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=a8fc3dec&scoped=true&", function () {
      api.rerender('a8fc3dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/order/Edit.vue"
export default component.exports